module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-16-svgrepo-com.ffdea11c.svg";